/**
 * Complemento de pago en borrador sin timbrar (CFDI tipo P, $0).
 */
export function isComplementoBorradorSinTimbrar(invoice) {
  if (!invoice) return false
  const tipo = (invoice.tipo_factura || '').toLowerCase()
  const status = (invoice.status || '').toUpperCase()
  const hasUuid = Boolean((invoice.cfdi_uuid || '').trim())
  return tipo === 'complemento' && status === 'DRAFT' && !hasUuid
}

/** Muestra el botón Eliminar en la lista de facturas. */
export function invoiceShowsDeleteButton(invoice) {
  if (!invoice) return false
  if (isComplementoBorradorSinTimbrar(invoice)) return true
  return (
    invoice.status === 'DRAFT' ||
    (invoice.cfdi_uuid && invoice.ambiente_timbrado === 'pruebas')
  )
}

/** Permite ejecutar eliminación (alineado con can_delete del API + regla local de complemento). */
export function invoiceCanDelete(invoice) {
  if (!invoice) return false
  if (isComplementoBorradorSinTimbrar(invoice)) return true
  if (invoice.can_delete === true) return true
  if (invoice.can_delete === false) return false
  // API antiguo o caché sin can_delete: misma lógica que visibilidad del botón
  return invoiceShowsDeleteButton(invoice)
}

export function invoiceDeleteDisabledTitle(invoice) {
  if (invoiceCanDelete(invoice)) return 'Eliminar factura'
  if (isComplementoBorradorSinTimbrar(invoice)) return 'Eliminar complemento en borrador'
  return invoice.delete_blocked_reason || 'No se puede eliminar esta factura'
}
